<template>
  <!-- 港澳台弹窗 -->
  <mt-popup v-model="visible"
            position="bottom"
            class="g-bottom-popup"
            :closeOnClickModal="false">
    <div class="popup-container">
      <div class="popup-top">
        <span class="title">{{title}}</span>
        <i class="iconfont icon-icon_close icon-close"
           @click.stop="close()"></i>
      </div>
      <div class="content-container"
           v-if="cityTreeList.length>0">
        <div class="content-tabs">
          <div class="content-tab"
               :class="{'is-active':selecteIndex === (index-1)}"
               v-for="index in 3"
               :key="index"
               v-show="selecteIndex >=(index-1)"
               @click="handelToolbar(index-1)">
            <span class="tab-title">
              {{(valueKey?(values[index-1]?values[index-1][valueKey]:''):values[index-1]) || ['省份','城市','区县'][index-1]}}
            </span>
          </div>
        </div>
        <div class="content-list"
             v-show="selecteIndex === 0">
          <div class="content-item"
               :class="{'active':values.length>0 && (values[0][valueKey] === item[valueKey])}"
               v-for="(item,index) in cityTreeList"
               @click.stop="handelCityClick(item)"
               :key="index">
            <div class="content-name">
              <span class="char-style">
                <strong v-if="sort && index === 0">{{item[sortKey]}}</strong>
                <strong v-if="sort && index>=1">{{item[sortKey] === cityTreeList[index-1][sortKey]?'':item[sortKey]}}</strong>
              </span>
              <span>{{valueKey?item[valueKey]:item}}</span>
            </div>
            <i class="iconfont"
              :class="values.length>0 && (values[0][valueKey] === item[valueKey]) ? 'icon-check-circle' : 'icon-check-button-off'" />
          </div>
        </div>
        <div class="content-list"
             v-show="selecteIndex === 1">
          <div class="content-item"
               :class="{'active':values.length>1 && (values[1][valueKey] === item[valueKey])}"
               v-for="(item,index) in cities"
               @click.stop="handelCityClick(item)"
               :key="index">
              <div class="content-name">
                <span class="char-style">
                  <strong v-if="sort && index === 0">{{item[sortKey]}}</strong>
                  <strong v-if="sort && index>=1">{{item[sortKey] === cities[index-1][sortKey]?'':item[sortKey]}}</strong>
                </span>
                <span>{{valueKey?item[valueKey]:item}}</span>
              </div>
              <i class="iconfont"
                :class="values.length>1 && (values[1][valueKey] === item[valueKey]) ? 'icon-check-circle' : 'icon-check-button-off'" />
          </div>
        </div>
        <div class="content-list"
             v-show="selecteIndex === 2">
          <div class="content-item"
               :class="{'active':values.length>2 && (values[2][valueKey] === item[valueKey])}"
               v-for="(item,index) in districts"
               @click.stop="handelCityClick(item)"
               :key="index">
              <div class="content-name">
                <span class="char-style">
                  <strong v-if="sort && index === 0">{{item[sortKey]}}</strong>
                  <strong v-if="sort && index>=1">{{item[sortKey] === districts[index-1][sortKey]?'':item[sortKey]}}</strong>
                </span>
                <span>{{valueKey?item[valueKey]:item}}</span>
              </div>
              <i class="iconfont"
                :class="values.length>2 && (values[2][valueKey] === item[valueKey]) ? 'icon-check-circle' : 'icon-check-button-off'" />
          </div>
        </div>
      </div>
    </div>
  </mt-popup>
</template>

<script>
import { Popup } from 'mint-ui'
import eventBus from '@/plugin/eventBus'

export default {
  name: '',
  mixins: [],
  components: {
    'mt-popup': Popup
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      defalut: false
    },
    title: {
      default: '选择省市区'
    },
    cityTreeList: {
      default: () => {
        return []
      }
    },
    sort: {
      type: Boolean,
      default: false
    },
    sortKey: {
      default: ''
    },
    valueKey: {
      default: ''
    },
    children: {
      default: ''
    }
  },
  data () {
    return {
      selecteIndex: 0,
      values: [],
      provinces: this.cityTreeList,
      cities: [],
      districts: []
    }
  },
  computed: {},
  watch: {
    cityTreeList (val) {
      this.provinces = val
    }
  },
  filters: {},
  directives: {},
  created () {},
  mounted () {
    eventBus.$on('resetPopup', () => {
      this.handelReSet()
    })
  },
  methods: {
    open () {
      this.$emit('change', true)
    },
    close () {
      this.$emit('change', false)
    },
    handelToolbar (index) {
      if (this.selecteIndex !== index) {
        this.values.splice(index + 1, 2 - index)
        this.selecteIndex = index
      }
    },
    handelCityClick (data) {
      const setData = (obj, index) => {
        const copy = { ...obj }
        delete copy[this.children]
        this.$set(this.values, index, copy)
      }
      switch (this.selecteIndex) {
        case 0:
          this.cities = data[this.children]
          this.selecteIndex = 1
          setData(data, 0)
          break
        case 1:
          this.districts = data[this.children]
          setData(data, 1)
          if (!this.districts) {
            this.$emit('confirm', this.values)
            this.close()
          } else {
            this.selecteIndex = 2
          }
          break
        case 2:
          setData(data, 2)
          this.$emit('confirm', this.values)
          this.close()
          break
        default:
          break
      }
    },
    // 重置选择
    handelReSet () {
      this.selecteIndex = 0
      this.values.length = 0
    },
    setValues (values) {
      this.values = values
      this.selecteIndex = values.length - 1
      const province = this.cityTreeList.find(
        (element) => element.areaCode === values[0].areaCode
      )
      this.cities = province?.childArea || []
      const city = this.cities.find(
        (element) => element.areaCode === values[1].areaCode
      )
      this.districts = city?.childArea || []
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
